module.exports = __webpack_public_path__ + "static/media/noun_Idea_2339722.e84b09fa.svg";